import React, { Fragment, useEffect, useState, useMemo, useCallback } from 'react';
import { Container, Row } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumbs } from '../../../../AbstractElements';
import { getTotalAvailableTermsAPI } from '../../../../Library/apis/index';
import TermSavingsTable from './TermSavingsTable';

const TermSavings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const LIMIT = 20;

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  
  const [currentPage, setCurrentPage] = useState(Number(queryParams.get('page')) || 1);
  const [lastKnownPage, setLastKnownPage] = useState(Number(queryParams.get('page')) || 1);
  
  const [activeFilters, setActiveFilters] = useState({
    firstName: queryParams.get('firstName') || '',
    lastName: queryParams.get('lastName') || '',
    userId: queryParams.get('userId') || '',
    terms: queryParams.get('terms') || '',
    status: queryParams.get('status') || '',
    dateFrom: queryParams.get('dateFrom') || '',
    dateTo: queryParams.get('dateTo') || '',
  });

  const fetchData = useCallback((newFilters, newPage) => {
    // Sync UI state to URL
    const params = new URLSearchParams();
    if (newPage > 1) params.set('page', newPage);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) params.set(key, newFilters[key]);
    });
    navigate({ search: params.toString() }, { replace: true });

    setIsLoading(true);
    getTotalAvailableTermsAPI(newFilters, newPage, LIMIT)
      .then(res => {
        setData(res.body || []);
        setTotalRows(res.pagination?.total || 0);
        setCurrentPage(newPage);
        setActiveFilters(newFilters);

        // Memory Logic: If no search is active, remember this page
        const isSearching = Object.values(newFilters).some(v => !!v);
        if (!isSearching) {
          setLastKnownPage(newPage);
        }
      })
      .catch(() => {
        setData([])
        setTotalRows(0);
      })
      .finally(() => setIsLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchData(activeFilters, currentPage);
  }, []);

  const handleSearch = (filters) => fetchData(filters, 1);
  const handlePageChange = (page) => fetchData(activeFilters, page);
  const handleReset = () => fetchData({}, lastKnownPage);
  const handleRefresh = () => fetchData(activeFilters, currentPage);


  return (
    <Fragment>
      <Breadcrumbs mainTitle='Reports/Records' />
      <Container fluid={true}>
        <Row className='widget-grid'>
          <TermSavingsTable
            data={data}
            isLoading={isLoading}
            totalRows={totalRows}
            currentPage={currentPage}
            onSearch={handleSearch}
            onPageChange={handlePageChange}
            onReset={handleReset}
            onRefresh={handleRefresh}  
            activeFilters={activeFilters}
            limit={LIMIT}
          />
        </Row>
      </Container>
    </Fragment>
  );
};

export default TermSavings;